import { Box } from '@mui/material';
import { FC } from 'react';
import { TaskContentBox } from './shared/taskContentBox';
import { TableProps } from './shared/tables/columns';

export const ExportsOverview: FC = () => {
  const tableProps: TableProps = {
    hideFooter: false,
    autoHeight: true,
    sx: {
      '& .MuiDataGrid-virtualScroller': { overflowX: 'auto !important' },
      '& .MuiDataGrid-main': { minHeight: '320px' }
    },
    rowHeight: 48
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto auto',
        gap: '1.5rem',
        height: '100%'
      }}
    >
      <TaskContentBox tableProps={tableProps} type="import" paddingTop="2px" />
      <TaskContentBox tableProps={tableProps} type="export" paddingTop="2px" />
    </Box>
  );
};
